export default {
  pageTitle: 'Transaction Reports',
  statisticsTitle: 'Transaction Statistics',
  dateRangePlaceholder: {
    start: 'Start Time',
    end: 'End Time',
  },
  transferInfo: {
    modalTitle: 'Transaction Info Statistics',
  },
  transferTable: {
    detailButton: 'Details',
  },
  tabs: {
    openPosition: 'Open Position',
    closePosition: 'Close Position',
    pendingOrder: 'Pending Order',
  },
  accountSelector: {
    placeholder: 'Select Account',
    searchPlaceholder: 'Search',
    title: 'Account Name',
  },
  trend: {
    up: 'Up',
    down: 'Down',
  },
  summaryCards: {
    accountBalance: 'Account Balance',
    accountNetValue: 'Account Net Value',
    totalBonusAmount: 'Total Bonus Amount',
  },
  statisticsInfo: {
    tradeVolume: {
      label: 'Trade Volume',
      unit: 'lot',
    },
    tradeCount: {
      label: 'Trade Count',
      unit: 'count',
    },
    commission: {
      label: 'Commission',
      unit: 'USD',
    },
    interest: {
      label: 'Interest',
      unit: 'USD',
    },
    orderProfitLoss: {
      label: 'Order P&L',
      unit: 'USD',
    },
    totalProfitLoss: {
      label: 'Total P&L',
      unit: 'USD',
    },
    depositWithdrawCount: {
      label: 'Deposit/Withdraw Count',
      unit: 'count',
    },
    totalDepositAmount: {
      label: 'Total Deposit Amount',
      unit: 'USD',
    },
    totalWithdrawAmount: {
      label: 'Total Withdraw Amount',
      unit: 'USD',
    },
    netDepositAmount: {
      label: 'Net Deposit Amount',
      unit: 'USD',
    },
  },
  tableColumns: {
    mtServer: 'MT Server',
    accountType: 'Account Type',
    mtAccount: 'MT Account',
    currency: 'Account Currency',
    leverage: 'Leverage',
    balance: 'Balance',
    equity: 'Equity',
    unrealizedPL: 'Unrealized P/L',
    credit: 'Credit',
    tradeVolumeHands: 'Trade Volume (lot)',
    tradeVolumeUSD: 'Trade Volume (Million USD)',
    tradeCount: 'Trade Count',
    commission: 'Commission',
    interest: 'Interest',
    orderProfitLoss: 'Order P&L',
    totalProfitLoss: 'Total P&L',
    depositWithdrawCount: 'Deposit/Withdraw Count',
    totalDepositAmount: 'Total Deposit Amount',
    totalWithdrawAmount: 'Total Withdraw Amount',
    netDepositAmount: 'Net Deposit Amount',
    transferInAmount: 'Transfer In Amount',
    transferOutAmount: 'Transfer Out Amount',
    netTransferAmount: 'Net Transfer Amount',
  },
  detail: {
    statistics: {
      'page-title': 'Transaction Report Detail',
      'account-balance': 'Account Balance',
      'account-margin-free': 'Account Margin Free',
      'account-credit': 'Account Credit',
      'floating-profit-loss': 'Floating Profit/Loss',
      'trade-count': 'Trade Count',
      'trade-number': 'Trade Number',
      volume: {
        label: 'Trade Volume',
        unit: 'lot',
      },
      trade_nums: {
        label: 'Trade Count',
        unit: 'count',
      },
      close_nums: {
        label: 'Trade Number',
        unit: 'count',
      },
      order_nums: {
        label: 'Order Number',
        unit: 'count',
      },
      commission_amount: {
        label: 'Commission',
        unit: 'USD',
      },
      swaps_amount: {
        label: 'Interest',
        unit: 'USD',
      },
      storage_amount: {
        label: 'Storage Fee',
        unit: 'USD',
      },
      profit_amount: {
        label: 'Order P&L',
        unit: 'USD',
      },
      total_profit_amount: {
        label: 'Total P&L',
        unit: 'USD',
      },

      account_type: {
        '-1': 'Unknown',
        0: 'Normal',
        1: 'Insurance',
        9: 'Social',
        10: 'PAMM',
      },
    },
    openPosition: {
      table: {
        header: {
          symbol: 'Trade Symbol',
          ticket: 'Order Number',
          cmd: 'Type',
          volume: 'Trade Volume(lot)',
          price: 'Price',
          tp_sl: 'Stop Loss/Take Profit',
          interest_fee: 'Interest/Fee',
          profit_amount: 'Profit',
          create_time: 'Trade Time',
        },
        enum: {
          cmd: {
            0: 'Buy',
            1: 'Sell',
          },
          price: {
            0: 'Open',
            1: 'Close',
          },
          tp_sl: {
            0: 'Take Profit',
            1: 'Stop Loss',
          },
          interest_fee: {
            0: 'Interest',
            1: 'Fee',
          },
        },
        button: {},
      },
    },
    closePosition: {
      table: {
        header: {
          symbol: 'Trade Symbol',
          ticket: 'Order Number',
          entry: 'Entry',
          cmd: 'Type',
          volume: 'Trade Volume',
          price: 'Price',
          tp_sl: 'Stop Loss/Take Profit',
          interest_fee: 'Interest/Fee',
          profit_amount: 'P&L',
          close_time: 'Trade Time',
        },
        enum: {
          entry: {
            0: 'IN',
            1: 'OUT',
            2: 'INOUT',
            3: 'OUTBY',
          },
          cmd: {
            0: 'Buy',
            1: 'Sell',
          },
          price: {
            0: 'Open',
            1: 'Current',
            2: 'Close',
          },
          tp_sl: {
            0: 'Take Profit',
            1: 'Stop Loss',
          },
          interest_fee: {
            0: 'Interest',
            1: 'Fee',
          },
        },
        button: {},
      },
    },
    pendingOrder: {
      table: {
        header: {
          symbol: 'Trade Symbol',
          ticket: 'Order Number',
          cmd: 'Type',
          volume: 'Trade Volume',
          price: 'Price',
          tp_sl: 'Stop Loss/Take Profit',
          order_time: 'Pending Time',
        },
        enum: {
          cmd: {
            0: 'Buy',
            1: 'Sell',
            2: 'Limit Buy',
            3: 'Limit Sell',
            4: 'Stop Loss Buy',
            5: 'Stop Loss Sell',
          },
          price: {
            0: 'Order Price',
            1: 'Current',
            2: 'Close',
          },
          tp_sl: {
            0: 'Take Profit',
            1: 'Stop Loss',
          },
        },
      },
    },
  },
}
